import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import resend from 'assets/images/login/resend.svg';
import cn from 'classnames';

import styles from './styles.scss';

const Timer = ({
  secondsLimit = 60,
  textLocale,
  onReset,
  resetLocale
}) => {
  const { t } = useTranslation();
  const [seconds, setSeconds] = useState(secondsLimit);
  const [isActive, setIsActive] = useState(true);
  const isLoading = useRef(false);
  const handleReset = () => {
    if (isLoading.current) {
      return;
    }

    isLoading.current = true;

    onReset().finally(() => {
      isLoading.current = false;
      setSeconds(secondsLimit);
      setIsActive(true);
    });
  };

  useEffect(() => {
    if (!isActive) {
      return;
    }

    let timeout;
    const runTimer = () => {
      timeout = setTimeout(() => {
        setSeconds((prevSeconds) => {
          if (prevSeconds >= 2) {
            runTimer();
            return prevSeconds - 1;
          }

          setIsActive(false);
          return 0;
        });
      }, 1000);
    };

    runTimer();

    return () => {
      clearTimeout(timeout);
    };
  }, [isActive]);

  return (
    <div
      className={cn(styles.TimerContainer, {
        [styles.Resend]: !isActive
      })}
    >
      {isActive ? (
        t(textLocale, { sec: seconds })
      ) : (
        <span className={styles.Resend} onClick={handleReset}>
          <img src={resend} /> {t(resetLocale)}
        </span>
      )}
    </div>
  );
};

export default Timer;



// WEBPACK FOOTER //
// ./src/containers/Login/Form/Timer/index.js